import { OrderListResponseType } from "@sellar-io/api-v2/types";
import { BadgeZinc } from "../../components/badge/Badge";

export const OrderCheckoutSourceIndicator = ({
  checkoutSource,
}: {
  checkoutSource: OrderListResponseType[number]["checkoutSource"];
}) => {
  if (!checkoutSource) return null;

  return (
    <BadgeZinc>
      {checkoutSource === "storefront" ? "Storefront" : "Unified checkout"}
    </BadgeZinc>
  );
};
